import React, { useState, useEffect, useContext } from 'react';
import axios from '../../../utils/axios';
import { ModalWindow } from '../../atoms';
import { AttributeDetailModal } from '..';
import { DashboardContext, UserContext } from '../../../context';
import { default as t } from '../../../utils/i18n';
import './attribute-details-listing.scss';
import html2canvas from 'html2canvas';
import jsPdf from "jspdf";
import fileDownload from 'js-file-download';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/Download-icon.svg';
import config from '../../../utils/config';
import axiosStat from "axios";
//import { DashService } from '../../../services';
const AttributeDetailListing = props => {
    const HELP_SUPPORT_LINK = config.get('help', 'support_link');
    const { dashData } = useContext(DashboardContext);
     const { user } = useContext(UserContext);
     const userAccessToken = user?.tokens?.accessToken?.jwtToken;
     const username = user?.username;
    const [graphViewToggle, setGraphViewToggle] = useState(false);
    const [attributeDetailModalView, setAttributeDetailModalView] = useState(null);
    const [graphReportCreatedDate, setGraphReportCreatedDate] = useState('');
    const [showShaftGraphModal, setShowShaftGraphModal] = useState(false);
    const [showCurrentKPI, setShowCurrentKPI] = useState('');
    const [showCurrentCountry, setShowCurrentCountry] = useState(null);
    const [isBLSKpi, setIsBLSKpi] = useState(false);
    const [isEffectiveness, setIsEffectiveness] = useState(false);
    const [isVolume, setIsVolume] = useState(false);
    const blsKPIName = 'Brand Lift';
    const EffectivenessText1 = `${t('effectiveness.text1.part1')} <i>(${t('effectiveness.text1.part2')})</i>.`;
    const EffectivenessText2 = `${t('effec.text2.part1')}
    <i>'${t('effec.text2.part2')}'</i> ${t('effec.text2.part3')}`;
    const volumeText1 = `${t('vol.part1')} <i>(${t('vol.part2')})</i>.`;
    const volumeText2 = `${t('vol.text2.part1')} <i>'${t('vol.text2.part2')}'</i> ${t('vol.text2.part3')}`;
    const shapEffectiveAbout = t('shap.about');
     const shapEffectiveImpact = t('shap.impact');
    const volumeAbout = t('vol.abt');
    const volumeImpact = t('vol.impact');
   // const [snapshotDownloading, setSnapshotDownloading] = useState(false);
    const handleBackClick = (e) => {
        props.handleBackClick(e);
    }
    const handleViewClick = (e, ind, kpi) => {
        setAttributeDetailModalView({ data: e, index: ind, kpi: kpi,
            isBLSKpi: isBLSKpi,
            isEffectiveness:isEffectiveness,
            isVolume:isVolume})
    }
    // const handleClick = (e) => {
    //     //  DownloadFile("Sample.pdf");
    // }
    const handleDownload = (url, filename) => {
    //     axios.get(url, {
    //         responseType: 'blob',
    //         headers: {
    //             'x-access-token': userAccessToken,
    //             'x-user': username
    //     }
    // }) 
    axios({
        method: 'get',
        responseType: 'blob',
        url: url,
        headers: {
          'x-access-token': userAccessToken,
          'x-user': username,
        },
      }) .then((res) => {
                fileDownload(res.data, filename)
            })
    }
    const handleDownloadSSClick = () => {
        const icon = document.querySelector(".download-icon");
        icon.classList.add("active");
        
        var testdiv = document.getElementById("snapshot-container");
        html2canvas(testdiv, {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY,
            windowWidth: document.documentElement.offsetWidth,
            windowHeight: document.documentElement.offsetHeight,          // There is no deviation from the top so there is no need to modify
            backgroundColor: 'white',
            allowTaint: true,
            useCORS: true
        }).then(canvas => {
            //     const imgData = canvas.toDataURL("image/png");
            // //document.getElementById("imageid").src=imgData;

            // const pdf = new jsPdf("p", "mm", "a4");
            // const width = pdf.internal.pageSize.getWidth() * 80 / 100;
            // ////console.log(width);
            // const height = pdf.internal.pageSize.getHeight();
            // pdf.addImage(imgData, 'JPEG', 0, 0, width, height);
            // pdf.save(`shap-graph.pdf`);


            const image = canvas.toDataURL('image/jpeg', 1.0);
            const doc = new jsPdf('p', 'px', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            const widthRatio = pageWidth / canvas.width;
            const heightRatio = pageHeight / canvas.height;
            const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;

            const marginX = (pageWidth - canvasWidth) / 2;
            const marginY = (pageHeight - canvasHeight) / 2;

            doc.addImage(image, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
            doc.save(`shap-graph.pdf`);
            icon.classList.remove("active");

        });

    }
    const handleModalBackClick = (e) => {
        setAttributeDetailModalView(null);
    }


    const handleToggleShaftViewClick = () => {
        setShowShaftGraphModal(true);
    }

    const handleOnCloseShaftGraphModal = () => {
        setShowShaftGraphModal(false);
    };
const updateTimeFormat = (val) => {
    const d = new Date(val);
        const yyyy = d.getFullYear();
        let mm = d.getMonth() + 1; // Months start at 0!
        let dd = d.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
 // const date = d.getHours() + ':' + (d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes()) + " " + d.toLocaleDateString();
       
        return dd + '-' + mm + '-' + yyyy;
}
    useEffect(() => {
       
        setGraphReportCreatedDate(updateTimeFormat(props.tableRowData.createdAt));

    }, []);


    const countryFullName = (country,code) => {
        if(country && code && country.length && code.length){
        const result =  country.filter(o1 => code.some(o2 => o1.country_code === o2)).map(e => e.name);
        return result.sort().join(", ");
        }
     }

     const handleDownloadHelp = (url, filename) => {
        const userGuideUrl = url.replace(/\{(.*?)\}/gi,t('dashboard.link.helpAndSupport',true));
        const api = axiosStat.create({
          baseURL: axios.defaults.baseURL.slice(0,-4),
         });
         api.get(userGuideUrl, {
            responseType: 'blob',
        })
            .then((res) => {
                fileDownload(res.data, filename)
            })
    }

    useEffect(() => {
        if(dashData.kpiList){
            dashData.kpiList.map(kpi => {
                    if(props.tableRowData.criteria?.kpi === kpi.sys_id){
                    if(kpi.KPI_subcategory === blsKPIName) {
                        setIsBLSKpi(true);
                    }
                    if(kpi.KPI_type === "Effectiveness"){
                        setIsEffectiveness(true);
                    }
                    if(kpi.KPI_type === "Volume"){
                        setIsVolume(true);
                    }
                    setShowCurrentKPI(kpi.KPI_Metric);
                   }
                });
            }
            if(dashData.countryList){
                if(Array.isArray(props.tableRowData.criteria?.country)){
                setShowCurrentCountry(countryFullName(dashData.countryList,props.tableRowData.criteria?.country))
                }
                else{
                    setShowCurrentCountry(props.tableRowData.criteria?.country)
                }
            }
    }, [dashData]);



    return (
        <section>
            {/* <img id='imageid' src=''/> */}
            <div className='heading-btn-container'>
                <button className='return-insights' onClick={() => handleBackClick()}>
                    <i className="eva  eva-arrow-ios-back-outline"></i>
                    {t('details.attribute.page.return.label')}
                </button>
                <DownloadIcon className='download-icon'/>
                <button className='download-snapshot' onClick={() => handleDownloadSSClick()}>
                    <i className="eva eva-camera-outline"></i>
                    {t('download.snapshot.button.label')}
                </button>
            </div>


            <div className='attribute-listing-details'>
                <div className="instruction-container">
                    <div className="info-instruction">
                        <h3>{props.tableRowData.reportId}</h3>
                        <span>{t('report.nickname.label')}: {props.tableRowData.reportName}</span>
                    </div>
                    <div className="ques-instruction">
                        <span>{t('download.pdf.info.question')}</span>
                        <button onClick={() => { handleDownloadHelp( HELP_SUPPORT_LINK, 'help.pdf') }}>
                            <i className="eva eva-message-circle-outline"></i>
                            {t('download.pdf.button.label')}
                        </button>
                    </div>
                </div>

                <div className='selected-report-details'>
                    <span className='report-variable'>{t('report.variable.label')}</span>

                    <table>

                        <thead>
                            <tr>
                                <th scope="col">{t('reportTable.text.dateRange')} (DD-MM-YYYY)</th>
                                <th scope="col">{t('reportTable.text.advertiser')}</th>
                                <th scope="col">{t('reportTable.text.industry')}</th>
                                <th scope="col">{t('report.variable.thead.country')}</th>
                                <th scope="col">{t('reportTable.text.kpi')}</th>
                                <th scope="col">{t('report.variable.thead.created')} (DD-MM-YYYY)</th>

                            </tr>
                        </thead>

                        <tbody>
                            <tr>

                                <td>{updateTimeFormat(props.tableRowData.criteria['from_date'])} {t('report.variable.thead.date.range.to')} {updateTimeFormat(props.tableRowData.criteria['to_date'])}</td>
                                <td><span>{Array.isArray(props.tableRowData.criteria?.advertiser) ? props.tableRowData.criteria?.advertiser?.sort().join(', ') : props.tableRowData.criteria?.advertiser}</span></td>
                                <td><span>{Array.isArray(props.tableRowData.criteria?.industry) ? props.tableRowData.criteria?.industry?.sort().join(', ') : props.tableRowData.criteria?.industry}</span></td>
                                <td><span>{showCurrentCountry}</span></td>
                                {/* <td>{Array.isArray(props.tableRowData.criteria?.kpi) ? props.tableRowData.criteria?.kpi?.join(', ') : props.tableRowData.criteria?.kpi}</td> */}
                                <td>{showCurrentKPI}</td>
                                <td>{graphReportCreatedDate}</td>

                            </tr>

                        </tbody>
                    </table>
                </div>

                <div className='selected-report-attribute-details' >
               {isBLSKpi && <div className='bls-note'>
                    <i className="eva eva-info-outline"></i>
                    <span> {t('bls.info.warn')}</span>
                </div> } 
                    <h3>{t('detail.attribute.listing.heading')} 
                    { !isBLSKpi && 
                    <button onClick={() => handleToggleShaftViewClick()} className="toggle-shap-view">{t('detail.attribute.graph.toggle.button.label')}</button>
                }
                </h3>
                    { props.tableRowData.insights.rawData.warning_field ? 
                    <span className='warning-span'>
                      <i className="eva eva-alert-circle-outline" data-tip={'warning'} data-for="tool-tip"></i>
                        {props.tableRowData.insights.rawData.warning_field + ' Reports should be used for experimental purposes rather than as a basis for critical campaign planning decision.'}<br></br> </span>: ''}
                    <span>{t('detail.attribute.listing.subheading')}</span>
                    <div className='selected-report-attribute-details--table'>
                        <table>

                            <thead>
                                <tr>
                                    <th scope="col">{t('detail.attribute.listing.thead.rank')}</th>
                                    <th scope="col">{t('detail.attribute.listing.thead.category')}</th>
                                    <th scope="col" className='strategy'>{t('detail.attribute.listing.thead.statattribute')}</th>
                                 {!isBLSKpi && 
                                 <th scope="col">{
                                    isEffectiveness ? 'impact on Effectiveness' : isVolume ? 'Impact On Volume' :
                                    t('detail.attribute.listing.thead.impact')} (%)</th>
                                }
                                    <th scope="col"></th>
                                </tr>
                            </thead>

                            <tbody>

                                {
                                    props.tableRowData.insights.rawData.insights.map((row, index) => {
                                        return <tr className="form__table-row" key={index}>

                                            <td><span className={`rank ${row.attribute_impact < 3 ? 'a' : row.attribute_impact < 8 ? 'b' : row.attribute_impact < 11 ? 'c' : row.attribute_impact < 13 ? 'd' : row.attribute_impact < 16 ? 'e' : 'f'}`}>{row.attribute_impact}</span></td>
                                            <td>{row.category}</td>
                                            <td className='variable'><span>{row.title}</span></td>
                                            {!isBLSKpi && 
                                            
                                            <td className='impact'><span>{Number((row.marginal_cost_contribution).toFixed(1))}</span>
                                                {(row.marginal_cost_contribution > 0) ? (row.marginal_cost_contribution > 5) ? <i className="eva  eva-arrowhead-up-outline up"></i> : <i className="eva  eva-arrow-ios-upward-outline up"></i> :
                                                    (row.marginal_cost_contribution < -5) ? <i className="eva  eva-arrowhead-down-outline down"></i> : (row.marginal_cost_contribution === 0) ? <span /> : <i className="eva  eva-arrow-ios-downward-outline down"></i>
                                                }
                                            </td>
                                    }
                                            <td><button onClick={() => handleViewClick(row, row.attribute_impact , showCurrentKPI)} className="return-insights"><i className="eva  eva-arrow-forward-outline"></i>{t('detail.attribute.listing.graph.view.button.label')}</button></td>
                                        </tr>
                                    })
                                }


                            </tbody>
                        </table>
                    </div>

                </div>


                <div id='snapshot-container'>
                <div className='selected-report-details'>
                    <span className='report-variable'>{t('report.variable.label')}</span>

                    <table>

                        <thead>
                            <tr>
                                <th scope="col">{t('reportTable.text.dateRange')} (DD-MM-YYYY)</th>
                                <th scope="col">{t('reportTable.text.advertiser')}</th>
                                <th scope="col">{t('reportTable.text.industry')}</th>
                                <th scope="col">{t('report.variable.thead.country')}</th>
                                <th scope="col">{t('reportTable.text.kpi')}</th>
                                <th scope="col">{t('report.variable.thead.created')} (DD-MM-YYYY)</th>

                            </tr>
                        </thead>

                        <tbody>
                            <tr>

                            <td>{updateTimeFormat(props.tableRowData.criteria['from_date'])} {t('report.variable.thead.date.range.to')} {updateTimeFormat(props.tableRowData.criteria['to_date'])}</td>
                                    <td><span>{Array.isArray(props.tableRowData.criteria?.advertiser) ? props.tableRowData.criteria?.advertiser?.join(', ') : props.tableRowData.criteria?.advertiser}</span></td>
                                <td><span>{Array.isArray(props.tableRowData.criteria?.industry) ? props.tableRowData.criteria?.industry?.join(', ') : props.tableRowData.criteria?.industry}</span></td>
                                <td><span>{showCurrentCountry}</span></td>
                                  {/* <td>{Array.isArray(props.tableRowData.criteria?.kpi) ? props.tableRowData.criteria?.kpi?.join(', ') : props.tableRowData.criteria?.kpi}</td> */}
                                <td>{showCurrentKPI}</td>
                                <td>{graphReportCreatedDate}</td>

                            </tr>

                        </tbody>
                    </table>
                </div>
                    <div className='selected-report-attribute-details'>
                        <h3>{t('detail.attribute.listing.heading')}</h3>
                        { props.tableRowData.insights.rawData.warning_field ? 
                    <span className='warning-span'>
                      <i className="eva eva-alert-circle-outline" data-tip={'warning'} data-for="tool-tip"></i>
                        {props.tableRowData.insights.rawData.warning_field + ' Reports should be used for experimental purposes rather than as a basis for critical campaign planning decision.'}<br></br> </span>: ''}

                        <span>{t('detail.attribute.listing.subheading')}</span>
                        <div className='selected-report-attribute-details--table'>
                            <table>

                                <thead>
                                    <tr>
                                        <th scope="col">{t('detail.attribute.listing.thead.rank')}</th>
                                        <th scope="col">{t('detail.attribute.listing.thead.category')}</th>
                                        <th scope="col" className='strategy'>{t('detail.attribute.listing.thead.statattribute')}</th>
                                        {!isBLSKpi && 
                                            <th scope="col">{
                                                isEffectiveness ? 'impact on Effectiveness' : isVolume ? 'Impact On Volume' :
                                                t('detail.attribute.listing.thead.impact')} (%)</th>
                                        }
                                    </tr>
                                </thead>

                                <tbody>

                                    {
                                        props.tableRowData.insights.rawData.insights.map((row, index) => {
                                            return <tr className="form__table-row" key={index}>

<td><span className={`rank ${row.attribute_impact < 3 ? 'a' : row.attribute_impact < 8 ? 'b' : row.attribute_impact < 11 ? 'c' : row.attribute_impact < 13 ? 'd' : row.attribute_impact < 16 ? 'e' : 'f'}`}>{row.attribute_impact}</span></td>
                                                <td>{row.category}</td>
                                                <td className='variable'><span>{row.title}</span></td>
                                                <td className='impact'><span>{Number((row.marginal_cost_contribution).toFixed(1))}</span>
                                                    {(row.marginal_cost_contribution > 0) ? (row.marginal_cost_contribution > 5) ? <i className="eva  eva-arrowhead-up-outline up"></i> : <i className="eva  eva-arrow-ios-upward-outline up"></i> :
                                                        (row.marginal_cost_contribution < -5) ? <i className="eva  eva-arrowhead-down-outline down"></i> : (row.marginal_cost_contribution === 0) ? <span /> : <i className="eva  eva-arrow-ios-downward-outline down"></i>
                                                    }
                                                </td>
                                            </tr>
                                        })
                                    }


                                </tbody>
                            </table>
                        </div>
                    </div>
                    {!isBLSKpi && 
                    <img src={props.tableRowData.insights.overviewGraph} crossOrigin="anonymous"/> }
                   <div className="selected-report-attribute-context">
            <h3>{t('detail.attribute.about.graph.heading')}</h3>
            {isBLSKpi ? (
              <p>
                {t('bls.info.caution')}
              </p>
            ) : (
              <>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t(
                      isEffectiveness
                        ? EffectivenessText1
                        : isVolume
                        ? volumeText1
                        : 'detail.attribute.about.graph.detail1'
                    )
                      .replace(/~(.*?)~/g, function myFunction(x) {
                        x = '<i>' + x + '</i>';
                        return x;
                      })
                      .replaceAll('~', ''),
                  }}
                ></p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t(
                      isEffectiveness
                        ? EffectivenessText2
                        : isVolume
                        ? volumeText2
                        : 'detail.attribute.about.graph.detail2'
                    )
                      .replace(/~(.*?)~/g, function myFunction(x) {
                        x = '<i>' + x + '</i>';
                        return x;
                      })
                      .replaceAll('~', ''),
                  }}
                ></p>
              </>
            )}
          </div>
                </div>

        <div className="selected-report-attribute-context">
            <h3>{t('detail.attribute.about.graph.heading')}</h3>
            {isBLSKpi ? (
              <p>
                {t('bls.info.caution')}
              </p>
            ) : (
              <>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t(
                      isEffectiveness
                        ? EffectivenessText1
                        : isVolume
                        ? volumeText1
                        : 'detail.attribute.about.graph.detail1'
                    )
                      .replace(/~(.*?)~/g, function myFunction(x) {
                        x = '<i>' + x + '</i>';
                        return x;
                      })
                      .replaceAll('~', ''),
                  }}
                ></p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t(
                      isEffectiveness
                        ? EffectivenessText2
                        : isVolume
                        ? volumeText2
                        : 'detail.attribute.about.graph.detail2'
                    )
                      .replace(/~(.*?)~/g, function myFunction(x) {
                        x = '<i>' + x + '</i>';
                        return x;
                      })
                      .replaceAll('~', ''),
                  }}
                ></p>
              </>
            )}
          </div>
            </div>

            {/* slide modal view starts */}
            {attributeDetailModalView && <AttributeDetailModal insightDetails={attributeDetailModalView} handleModalBackClick={handleModalBackClick} />}
            {/* slide modal view ends */}


            {/* shaft Modal starts */}
            <ModalWindow
                className="fqa-modal--shapgraph"
                isOpen={showShaftGraphModal}
                onRequestClose={handleOnCloseShaftGraphModal}
                heading={t('details.attribute.shaf.graph.modal.heading')}
            >
                <div className="fqa-model">
                <button onClick={() => { handleDownload(props.tableRowData.insights.overviewGraph, 'SHAP.png') }} className="download" href="javascript.void(0)" >{t('details.attribute.shaf.graph.download.button.label')}</button>
                 
                <img src={props.tableRowData.insights.overviewGraph} crossOrigin="anonymous" />

                    <div className='info-container'>
                  
                        <div className='info'>
                            <h5>{t('details.attribute.shaf.graph.modal.info.heading')}</h5>
                            <p>{t(isEffectiveness ? shapEffectiveAbout : isVolume ? volumeAbout : 'details.attribute.shaf.graph.modal.info.desc1')}</p>
                            <p><span className='heading'>{t('details.attribute.info.heading.impact')}</span><span>{t(isEffectiveness ? shapEffectiveImpact : isVolume ? volumeImpact :'details.attribute.shaf.graph.modal.info.desc2')}</span></p>
                            <p><span className='heading'>{t('details.attribute.info.heading.legend')}</span><span>{t('details.attribute.shaf.graph.modal.info.desc3')}</span></p>
                            </div>
                    </div>
                   
                    {/* <img src='https://via.placeholder.com/500x1000' /> */}

                </div>
            </ModalWindow>

            {/* shaft Modal ends */}
        </section>
    );
};

export default AttributeDetailListing;
